(() => {
  const navs = Array.from(document.querySelectorAll('[data-extro-mobile-scroll-nav]'));
  if (navs.length === 0) return;

  const mobileQuery = window.matchMedia('(max-width: 740px)');
  let ticking = false;

  const update = () => {
    ticking = false;
    const visible = mobileQuery.matches && window.scrollY > 96;
    navs.forEach((nav) => nav.classList.toggle('is-visible', visible));
  };

  const requestUpdate = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-extro-mobile-collection-select]');
    if (!select || !select.value) return;
    window.location.assign(select.value);
  });

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  mobileQuery.addEventListener?.('change', update);
  update();
})();
